import { Injectable } from "@angular/core";
import { ApiProxyService } from "app/modules/shared/services/api-proxy.service";
import { Observable } from "rxjs";
import { ConfigService } from "./config.service";

@Injectable({
    providedIn: 'root'
})
export class AccessibilityService {
    constructor(private apiProxy: ApiProxyService, private configService: ConfigService) { }

    public isSdxFileAccessible(versionId: number): Observable<boolean> {
        return this.apiProxy.get<boolean>(`${this.configService.apiUrl}sdxfiles/sdxfile-exists-in-s3/${versionId}`);
    }

    public isProjectSpecificRbaccFileAccessible(specificationGuid: string) {
        return this.apiProxy.get<boolean>(`${this.configService.apiUrl}rbac/specificationGuid/${specificationGuid}`);
    }

    public isDefaultEntityRbaccFileAccessible(familyName: string,  generationName: string) {
        return this.apiProxy.get<boolean>(`${this.configService.apiUrl}rbac/defaultEntity/${familyName}/${generationName}`);
    }
}